import React, { useEffect, useState } from "react";
import Api from "../../Services/Api";

import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
    LogarithmicScale,
    LineController,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import {Grid} from "@mui/material";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    LogarithmicScale,
    PointElement,
    Title,
    Tooltip,
    Legend,
    LineController
);



const KPIS = ({dataForm}) => {
    const [KPIS, setKPIS] = useState(null);

    useEffect(() => {
        Api.adminKPIS(dataForm).then((r) => {
            setKPIS(r);
        });
    }, [dataForm]);

    const accumulatedProfit = KPIS?.reduce((acc, item) => {
        const prevValue = acc.length > 0 ? acc[acc.length - 1] : 0;
        acc.push(prevValue + item["Profit ($)"]);
        return acc;
    }, []);

    const chartData = {
        labels: KPIS?.map((item) => item.date),
        datasets: [




            {
                label: "Searches RPM ($)",
                data: KPIS?.map((item) => item['Searches RPM ($)']),
                type: "line",
                yAxisID: "percentAxis",
                backgroundColor: "blue",
                borderColor: "blue",
                tension: 0.4,
            },


            {
                label: "Coverage (%)",
                data: KPIS?.map((item) => item['Coverage (%)']),
                type: "line",
                yAxisID: "percentAxis",
                backgroundColor: "orange",
                borderColor: "orange",
                tension: 0.4,

            },

            {
                label: "CTR (%)",
                data: KPIS?.map((item) => item['CTR (%)']),
                type: "line",
                yAxisID: "percentAxis",
                backgroundColor: "black",
                borderColor: "black",
                tension: 0.4,

            },

            {
                label: "Opticks (%)",
                data: KPIS?.map((item) => item['Opticks (%)']),
                type: "line",
                yAxisID: "percentAxis",
                backgroundColor: "red",
                borderColor: "red",
                tension: 0.4,

            },
            {
                label: "Profit ($)",
                data: KPIS?.map((item) => item['Profit ($)']),
                backgroundColor: "#28a745",
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                type: "linear",
                display: true,
                position: "left",
                ticks: {
                    callback: function(value) {
                        return "$" + value;
                    },
                },
            },
            percentAxis: {
                type: "logarithmic",
                display: true,
                position: "right",
                min: 0,

            },
        },
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            padding: '4px 8px',
            fontSize: 12,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 12,
            padding: '4px 8px',
        },
        '&.sticky': {
            position: 'sticky',
            left: 0,
            zIndex: 1,
            width: "200px",
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            borderRight: '2px solid rgba(224, 224, 224, 1)',
            padding: '4px 8px',
        },
    }));






    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));



    const uniqueDates = KPIS
        ? Array.from(new Set(KPIS.map((item) => item.date)))
        : [];
    const uniqueMetrics = KPIS
        ? Array.from(
            new Set(
                KPIS.flatMap((item) =>
                    Object.keys(item).filter((key) => key !== "date")
                )
            )
        )
        : [];



    return (

            <Grid container spacing={2}>
                <Grid item xs={12} md={6} style={{ height: "500px", width: "100%" }}>
            <div style={{ height: "100%", width: "100%" }}>
                {KPIS ? (
                    <Bar data={chartData} options={chartOptions} />
                ) : (
                    <p>Loading data...</p>
                )}
            </div>
                </Grid>
                <Grid item xs={12} md={6} style={{ height: "500px", width: "100%" }}>
                    <div style={{ height: "100%", overflow: "auto" }}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                            <TableHead>
                                <TableRow style={{ zIndex: 100 }}>
                                    <StyledTableCell className="sticky">Metric</StyledTableCell>
                                    {uniqueDates.map((date) => {
                                        const formattedDate = date.substring(5);
                                        return (
                                            <StyledTableCell key={date} align="right">
                                                {formattedDate}
                                            </StyledTableCell>
                                        );
                                    })}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {uniqueMetrics.map((metric) => (
                                    <StyledTableRow key={metric}>
                                        <StyledTableCell component="th" scope="row" style={{ minWidth: '150px' }} className="sticky">
                                            {metric}
                                        </StyledTableCell>
                                        {uniqueDates.map((date) => {
                                            const item = KPIS.find((el) => el.date === date);
                                            const value = item ? item[metric] : "-";
                                            const parsedValue = parseFloat(value);
                                            const formattedValue =
                                                !isNaN(parsedValue)
                                                    ? new Intl.NumberFormat().format(parsedValue.toFixed(0))
                                                    : value;
                                            return (
                                                <StyledTableCell key={`${metric}-${date}`} align="right">
                                                    {formattedValue}
                                                </StyledTableCell>
                                            );
                                        })}
                                    </StyledTableRow>
                                ))}
                            </TableBody>


                        </Table>
                    </TableContainer>
                    </div>

                </Grid>
            </Grid>
    );
};

export default KPIS;
